export default __webpack_public_path__ + "static/media/icon_person.7e7ee89a.svg";